import Instance from "../../../../Axios";

// New Actions for the app

const GetCredViaturaFicheirosPermanente = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/viaturaFicheirosPermanente`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VIATURA_FICHEIROS_PERMANENTE",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredViaturaFicheirosPermanente;
